import { render } from "./DetailSearchComponent.vue?vue&type=template&id=37f5f2b3"
import script from "./DetailSearchComponent.vue?vue&type=script&lang=js"
export * from "./DetailSearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__